import { Component } from '@angular/core';
import { soundpostOrchestrationRunStepEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Orchestration Run Steps') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostorchestrationrunstep-form',
    templateUrl: './soundpostorchestrationrunstep.form.component.html'
})
export class soundpostOrchestrationRunStepFormComponent extends BaseFormComponent {
    public record!: soundpostOrchestrationRunStepEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

